import { IListApiRequest } from 'api/types'

export enum INTEGRATION_SYSTEM_TYPES {
  PDF_MERGE = 'PDF_MERGE',
  INVOICE = 'INVOICE',
  BANK_FEED = 'BANK_FEED',
  XERO = 'XERO',
  EFT_SURE = ' EFT_SURE',
  DOCUMENT_AI = 'DOCUMENT_AI',
  SISS_BANK_FEED = 'SISS_BANK_FEED'
}

export interface Integration {
  id?: string;
  name: string;
  active: boolean;
  storageBucketName: string;
  sourceSystem: {
    id: number
  };
  targetSystem: {
    id: number
  };
  integrationSystem: INTEGRATION_SYSTEM_TYPES;
}
export interface IntegrationSaveRequest {
  integrationDTO: Integration;
}

export interface IntegrationListResponse {
  totalElements?: number;
  content?: Integration[];
  integrationDTO: Integration;
}
export type IntegrationListRequest = IListApiRequest<Integration>
